import React from "react";
import { Text, View, StyleSheet, Font } from "@react-pdf/renderer";
import { useTranslation } from "react-i18next";
import i18n from "../../i18n";

Font.register({
  family: "DM Sans",
  fonts: [{ src: "/fonts/DMSans-Regular.ttf", fontWeight: "normal" }],
});

Font.register({
  family: "DM Serif Display",
  fonts: [{ src: "/fonts/DMSerifDisplay-Regular.ttf", fontWeight: "normal" }],
});

const FOOTER_MUTED = "#767682";
const FOOTER_BRAND = "#1A1A2E";
const FOOTER_BORDER = "#E6E6EB";

const styles = StyleSheet.create({
  footer: {
    position: "absolute",
    bottom: "6mm",
    left: "14mm",
    right: "14mm",
  },
  divider: {
    borderTopWidth: 0.25,
    borderTopColor: FOOTER_BORDER,
    marginBottom: "5mm",
  },
  textRow: {
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
  },
  mutedText: {
    fontSize: 8.5,
    fontFamily: "DM Sans",
    color: FOOTER_MUTED,
  },
  brandText: {
    fontSize: 10,
    fontFamily: "DM Serif Display",
    color: FOOTER_BRAND,
  },
});

function buildMediaKitPdfFooterParts(): { beforeBrand: string; brand: string } {
  const locale = i18n.language?.startsWith("en") ? "en-US" : "es-CL";
  const datePart = new Date().toLocaleDateString(locale, {
    day: "numeric",
    month: "long",
  });
  return {
    beforeBrand: `${i18n.t("mediaKit:generatedOn", { date: datePart })} `,
    brand: "Podscope",
  };
}

export function MediaKitPdfFooter(): React.ReactElement {
  useTranslation("mediaKit");
  const { beforeBrand, brand } = buildMediaKitPdfFooterParts();

  return (
    <View style={styles.footer} fixed>
      <View style={styles.divider} />
      <View style={styles.textRow}>
        <Text style={styles.mutedText}>{beforeBrand}</Text>
        <Text style={styles.brandText}>{brand}</Text>
      </View>
    </View>
  );
}
